import axios from 'axios'

export const buscarFeriadosPorAno = async (ano) => {
	return await axios.get(`https://brasilapi.com.br/api/feriados/v1/${ano}`)
}
